import React from 'react';
import ReactDOM from 'react-dom';

import createStore from './store'
import { Provider } from 'react-redux'

import createHistory from 'history/createBrowserHistory'

import { ConnectedRouter } from 'react-router-redux'
import JssProvider from 'react-jss/lib/JssProvider';
import { MuiThemeProvider } from 'material-ui/styles';
import createThemeContext from './style/createContext'

import App from './components/App'
import {initialLoLoginCheck, renewTokenCheck} from './actions'
import ReactAI from 'react-appinsights';

//import registerServiceWorker from './registerServiceWorker';

const history = createHistory()
const store = createStore(history);

ReactAI.init({instrumentationKey: process.env.REACT_APP_APP_INSIGHTS_KEY}, history);
ReactAI.setAppContext({environment: process.env.REACT_APP_APP_INSIGHTS_ENVIRONMENT});

if(window.location.pathname === '/renew')
{
    store.dispatch(renewTokenCheck())
}
else
{
    store.dispatch(initialLoLoginCheck())

    const themeContext = createThemeContext();

    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <JssProvider registry={themeContext.sheetsRegistry} jss={themeContext.jss}>
                    <MuiThemeProvider theme={themeContext.theme} sheetsManager={themeContext.sheetsManager}>
                        <App />
                    </MuiThemeProvider>
                </JssProvider>
            </ConnectedRouter>
        </Provider>,
        document.getElementById('root')
    )
    //registerServiceWorker();
}




// WEBPACK FOOTER //
// ./src/index.js